<template>
  <div>
    <a-table
      :rowKey="record => record.id"
      :columns="columns"
      :dataSource="data"
      :scroll="{ x: 3000}"
      bordered>
      <span slot="Serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="turnoverMode" slot-scope="text" >
        <span
          v-for="(value,key) in turnoverModeData"
          :key="key">
          <span v-if="text===value.ordinal">{{ value.name }}</span>
        </span>
      </span>
      <span slot="dataSource" slot-scope="text" >
        <span
          v-for="(value,key) in dataSourceData"
          :key="key">
          <span v-if="text===value.ordinal">{{ value.name }}</span>
        </span>
      </span>
      <span slot="available" slot-scope="text">
        <a-checkbox :checked="text" />
      </span>
      <span slot="inner" slot-scope="text">
        <a-checkbox :checked="text" />
      </span>
      <span slot="background" slot-scope="text">
        <a-checkbox :checked="text" />
      </span>

      <span slot="approved" slot-scope="text">
        <a-checkbox :checked="text" />
      </span>

      <span slot="downstream" slot-scope="text">
        <a-checkbox :checked="text" />
      </span>
      <span slot="upstream" slot-scope="text">
        <a-checkbox :checked="text" />
      </span>
    </a-table>
  </div>
</template>

<script>
    import {findOne} from '@/api/Api';
import {exportToExcel} from '@/components/Excel/export/exportFunction'
import {excelName, filterVal, headerData} from '@/api/dto_js/import/customerBaseData'
import {nameToOrdinal, ordinalToName, transformData} from '@/api/dto_js/import/transform'
    import {checkFieldType} from '@/utils/field-check'

export default {
    name: 'CustomerBaseData',
    data() {
      return {
        data :[],
        // 表头
        columns: [
          {
            title: '序号',
            scopedSlots: { customRender: 'Serial'}
          },
          {
            title: '货主名称',
            dataIndex: 'storer.name'
          },
          {
            title: '客户编号',
            dataIndex: 'no'
          },
          {
            title: '客户名称',
            dataIndex: 'name'
          },
          {
            title: '助记码',
            dataIndex: 'mnemonicCode'
          },
          {
            title:'地址',
            dataIndex:'address'
          },

          {
            title:'地区',
            dataIndex:'district'
          },
          {
            title:'等级',
            dataIndex:'grade'
          },
          {
            title:'识别',
            dataIndex:'identifier'
          },
          {
            title:'批号数',
            dataIndex:'numberOfLot'
          },
          {
            title:'上级客户',
            dataIndex:'parent.name'
          },
          {
            title:'所在地',
            dataIndex:'seat'
          },
          {
            title:'标签分割量',
            dataIndex:'separationOfLabel'
          },
          {
            title:'简称',
            dataIndex:'shortName'
          },
          {
            title:'客户分类',
            dataIndex:'classification'
          },
          {
            title:'库存周转方式',
            dataIndex: 'turnoverMode',
            scopedSlots: { customRender: 'turnoverMode' }
          },
          {
            title: '联系人',
            dataIndex: 'businessman'
          },
          {
            title: '电话',
            dataIndex: 'phone'
          },
          {
            title: '数据源',
            dataIndex: 'dataSource',
            scopedSlots: { customRender: 'dataSource' }
          },
          {
            title: '是否内部客户',
            dataIndex: 'inner',
            scopedSlots: { customRender: 'inner' }
          },
          {
            title: '是否后台客户',
            dataIndex: 'background',
            scopedSlots: { customRender: 'background' }
          },
          {
            title: '是否已审核',
            dataIndex: 'approved',
            scopedSlots: { customRender: 'approved' }
          },
          {
            title: '是否可用',
            dataIndex: 'available',
            scopedSlots: { customRender: 'available' }
          },
          {
            title: '是否下游客户',
            dataIndex: 'downstream',
            scopedSlots: { customRender: 'downstream' }
          },
          {
            title: '是否上游客户',
            dataIndex: 'upstream',
            scopedSlots: { customRender: 'upstream' }
          }
        ],
        classificationData:[],
        turnoverModeData:[],
        dataSourceData:[]
      }
    },
    mounted(){
        findOne('fieldFactory', {no: 'TURNOVER_MODE'}).then(body => {
        body.dictionaries.forEach(item=>{
          this.turnoverModeData.push(item)
        })
      })
        findOne('fieldFactory', {no: 'DATA_SOURCE'}).then(body => {
        body.dictionaries.forEach(item=>{
          this.dataSourceData.push(item)
        })
      })
    },
    methods:{
      getData(data){
        this.data=data
      },
      exportData(){
        const list = JSON.parse(JSON.stringify(this.data))
        for (let x=0;x<list.length;x++){
          if(list[x].storer){
            list[x].storer=list[x].storer.name
          }
          list[x]=ordinalToName(list[x],'dataSource',this.dataSourceData)
          list[x]=ordinalToName(list[x],'turnoverMode',this.turnoverModeData)
        }
        exportToExcel(headerData,filterVal,list,excelName)
      },
      transformData(data){
        // storer dataSource  turnoverMode尚未转换
        const list=transformData(headerData,filterVal,data)
        // this.$message.info(JSON.stringify(list))
        for (let i = 0; i < list.length; i++) {
          if (list[i].storer) {
            list[i].storer = { name: list[i].storer }
          }
          list[i] = nameToOrdinal(list[i], 'dataSource', this.dataSourceData)
          list[i] = nameToOrdinal(list[i], 'turnoverMode', this.turnoverModeData)
        }
        this.data = list
      },
      save() {

        const arrCustomer = []

        this.data.forEach(item => {
          item['id'] = null
          item['version'] = 0

          const map = new Map()
          map.set('type', 'customerPersister')
          map.set('dataId', item.no)
          map.set('content', item)
          const returnValue = checkFieldType(map)
          arrCustomer.push(returnValue)
        })
        // this.$message.info(JSON.stringify(this.data))
        this.$emit('sendSave', arrCustomer)
      },
      // save(){
      //   this.data.forEach(item=>{
      //     item['id']=null
      //     item['version']=0
      //   })
      //   // this.$message.info(JSON.stringify(this.data))
      //   this.$emit('sendSave',this.data)
      // },
      clear() {
        this.data = []
      }
    }
  }
</script>

<style scoped>

</style>